module.exports = __webpack_public_path__ + "img/1970East-056_WEB-min.5fce5991.jpg";